import * as React from 'react';
import InputUnstyled from '@mui/base/InputUnstyled';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const blue = {
  100: '#DAECFF',
  200: '#80BFFF',
  400: '#3399FF',
  600: '#0072E5',
};

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
};

const StyledInputElement = styled('input')(
  ({ theme }) => `
  width: 100%;
  font-size: 0.875rem;
  font-family: IBM Plex Sans, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : "white"};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[300]};
  border-radius: 8px;
  padding: 12px 12px;

  &:hover {
    border-color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
  }

  &:focus {
    outline: 1px solid ${theme.palette.mode === 'dark' ? blue[600] : "gray"};
  }
`,
);

const Input = React.forwardRef((props, ref) => 
 (
    <InputUnstyled components={{ Input: StyledInputElement }} {...props} ref={ref} />
  )
);

CustomInput.propTypes = {
 placeholder: PropTypes.string
}

export default function CustomInput({ placeholder }) {
  return <Input aria-label="Demo input" placeholder={placeholder}/>;
}
